import { render, staticRenderFns } from "./CrosswordPublisherGridList.vue?vue&type=template&id=ed40b0ca&"
import script from "./CrosswordPublisherGridList.vue?vue&type=script&lang=js&"
export * from "./CrosswordPublisherGridList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports